import {
  useRetrieveResourceGroups,
  useRetrieveCurrentPlanzone,
} from "@planzone/view-models";
import { Group, Identifiable, Resource } from "@planzone/dto";
import { useWorkspaceContext } from "@scenes/workspaceContext";

function removeDuplicates(
  resources: Identifiable<Resource>[],
): Identifiable<Resource>[] {
  return Object.values(
    resources.reduce(
      (acc, resource) => ({ ...acc, [resource.uuid]: resource }),
      {},
    ),
  );
}

function extractGroupsRessource(groups: Group[]) {
  return groups.reduce<Identifiable<Resource>[]>(
    (acc, { resourceType, resources }) =>
      resourceType === "project"
        ? [
            ...acc,
            ...removeDuplicates(resources.map(({ resource }) => resource)),
          ]
        : [...acc, ...removeDuplicates(resources)],
    [],
  );
}

function useGroups() {
  const { planzone } = useRetrieveCurrentPlanzone();
  const ctx = useWorkspaceContext();
  const isInProject = ctx.type === "project";
  const {
    isRequestPending,
    isRequestSuccess,
    isRequestFailure,
    groups,
    retrieveResourceGroups,
  } = useRetrieveResourceGroups(isInProject ? ctx.project.uuid : planzone.uuid);

  return {
    isRequestPending,
    isRequestSuccess,
    isRequestFailure,
    groups,
    retrieveGroups: () =>
      retrieveResourceGroups({
        namespace: isInProject ? ctx.project.uuid : planzone.uuid,
        resourceType: isInProject ? "project" : "planzone",
      }),
  };
}

export { useGroups, extractGroupsRessource };
